<template>
  <div class="text-center">
    <v-dialog v-model="shower" width="560" scrollable persistent>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card class="rounded-lg">
          <v-card-title> {{ $t("Profile.editemail") }} </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-6">
            <v-layout row wrap justify-center align-center>
              <v-flex xs8 lg8 pt-6>
                <v-text-field
                  :label="$t('dashboard.email')"
                  class="pt-1"
                  v-model="Email"
                  required
                  outlined
                  dense
                  prepend-inner-icon="mdi-email"
                  :rules="[(v) => !!v || $t('email.text11')]"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pb-5 pa-3">
            <v-spacer></v-spacer>
            <v-btn color="#077893" dark @click="Fn_Save()">
              {{ $t("policyForm.save") }}
            </v-btn>
            <v-btn color="#077893" outlined @click="Fn_Close()">
              {{ $t("consentform.close") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import authorization from "@/functions/authorization.js";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  props: ["show", "data", "phone"],
  data: function () {
    return {
      valid: true,
      Email: "",
      Phone: "",
      ErrorMessageMail: "",
      rules: [
        (value) =>
          !value || value.size < 1000000 || this.$i18n.t("Profile.pictext3"),
      ],
    };
  },
  computed: {
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialogEmail");
        }
      },
    },
  },
  methods: {
    async Fn_Save() {
      if (this.$refs.form.validate()) {
        const payload = {
          AccountId: this.$cookies.get("OneAccountId"),
          Email: this.Email,
          Tel: this.Phone,
        };
        var Headers = {
          AccountId: this.$cookies.get("OneAccountId"),
        };
        var dataEncode = await authorization.encodeDataNew(payload);
        var auth = await authorization.encodeDataNew(Headers);
        var headers = { Authorization: "Bearer " + auth };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE + "token/UpdateAccount",
            { Data: dataEncode },
            { headers }
          )
          .then((response) => {
            this.loading = false;

            if (response.data.Status === "OK") {
              this.$emit("closeDialogEmail");
              this.$emit("reData");
              Toast.fire({
                icon: "success",
                title: response.data.Message,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    Fn_Close() {
      // this.Email = []
      this.ErrorMessageMail = "";
      // this.$refs.form.reset();
      this.$emit("closeDialogEmail");
    },
  },
  watch: {
    show(val) {
      if (val === true) {
        this.Email = this.data;
        this.Phone = this.phone;
      }
    },
  },
};
</script>
